import { useLocation, useNavigate } from "react-router-dom"
import { useState, useEffect } from "react";
import api from "../../api.js";
import toastHelpers from "../../helpers/toastHelper.js";
import useErrorContext from "../../hooks/useErrorContext.js";

export default function MailConfirmation() {
    const location = useLocation();
    const email = location.state ? location.state.email : null;
    const token = location.state ? location.state.token : null;

    const navigate = useNavigate();
    
    const [canResend, setCanResend] = useState(false);
    const resendInterval = 60000; // 1 min
    const resendIntervalSeconds = resendInterval / 1000;
    const [timer, setTimer] = useState(resendIntervalSeconds);

    const { dispatch:errorDispatch } = useErrorContext();

    const { toastError } = toastHelpers;

    // Check that the email and token are defined
    useEffect(() => {
        if (!email || !token) {
            errorDispatch({ type: '404_ERROR' }); 
        }
    }, [email, errorDispatch, token])

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer(prevTimer => {
                if (prevTimer <= 1) {
                    clearInterval(countdown);
                    setCanResend(true);
                    return resendIntervalSeconds; // Reset timer
                }

                return prevTimer - 1;
            });
        }, 1000);

        // Cleanup interval on component unmount
        return () => clearInterval(countdown);
    }, [timer, resendIntervalSeconds]);

    // API to resend the email
    const resendEmail = async () => {
        try {
            await api.post("/user/sendConfirmationEmail", 
                {}, 
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    }
                }
            );
            setCanResend(false);
            setTimer(resendIntervalSeconds);
        } catch (error) {
            if (error.response.data.error_confirmed) {
                // the user already confirmed
                toastError("Email already confirmed. Redirecting to sign in.");
                navigate("/sign-in");
            } else {
                toastError();
            }
        }
    };

    // Handle the resend of the email
    async function handleResend() {
        await resendEmail();
    }

    return (
        <div className="email-confirmation--background">
            <div className="email-confirmation--container">
                <lord-icon
                    src="https://cdn.lordicon.com/xtnsvhie.json"
                    trigger="hover"
                    colors="primary:#00ac97"
                    style={{ width: "100px", height: "100px", marginBottom: "10px" }}
                ></lord-icon>

                <h1>Email Confirmation</h1>
                <p>
                    <span>An email has been sent to </span>
                    <span className="light-green">{email}</span>
                    <span> confirm the validity of the email address. Please check your inbox and follow the instructions to complete your registration.</span>
                </p>

                <p className="resend-email--container">
                    <span>Can't find it? </span>
                    {canResend ? 
                        <button 
                            onClick={handleResend}
                            className="resend-otp--button"
                        >Resend</button>
                        :
                        <p>
                            <span>Resend in </span>
                            <span className="resend-otp--button">{timer}</span>
                            <span> seconds</span>
                        </p>
                    }
                </p>
            </div>
        </div>
    )
}